let env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'localhost', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );
let isLocalhost = false;

if ( env === 'localhost' ) {
    isLocalhost = true;
    env = 'qa';
}

export const currentEnv = env;

function getURL( url ) {
    if ( isLocalhost ) {
        return url.toLowerCase().replace( '(domain)', 'qa.recognition-now.io' );
    } else {
        return url.toLowerCase().replace( '(domain)', window.location.hostname );
    }
}

export const piersUrl = getURL( 'https://(domain)/api/v1/piers' );
export const cmxUrl = getURL( 'https://(domain)/api/v2/cmx' );
export const publicPrivacyUrl = getURL( 'https://(domain)/api/privacyapi/public/services/v1' );
export const privacyUrl = getURL( 'https://(domain)/api/privacyapi/services/v1' );
export const navigationUrl = getURL( 'https://(domain)/api/v2/navigation' );
export const notificationsUrl = getURL( 'https://(domain)/api/v1/notification-deck-service' );
export const brandingUrl = getURL( 'https://(domain)/api/v1/branding' );
export const webEventProxyUrl = getURL( 'https://(domain)/api/v1/web-event-proxy' );